import type { GivingInterval } from 'models';
import { Modal, Skeleton } from 'ui';
import { useGivingDetailQuery } from '../../../../../queries';
import { GiveNowCreateForm } from './give-now-create-form';

type P = {
  givingId: string;
  interval: GivingInterval;
  isOpened: boolean;
  onClose: () => void;
};

const GiveNowModal = ({ givingId, interval, isOpened, onClose }: P) => {
  const { data: givingContentObject, isLoading } = useGivingDetailQuery({
    id: givingId,
    options: { enabled: isOpened },
  });

  return (
    <Modal isOpened={isOpened} maskClosable={false} onCancel={onClose} title="My giving options" width="medium">
      <Modal.HugContent>
        {isLoading || !givingContentObject ? (
          <Skeleton paragraph={{ rows: 10 }} />
        ) : (
          <GiveNowCreateForm givingContentObject={givingContentObject} interval={interval} onClose={onClose} />
        )}
      </Modal.HugContent>
    </Modal>
  );
};

export default GiveNowModal;
